import { InterestItem } from "./styles"

interface InteressedItemProps{
    InterestItem:{
        name: string,
        icon: string
    }
}

export function InteressedItem(props: InteressedItemProps){
    return(
        <InterestItem>
            <i className={props.InterestItem.icon}></i>
            <p>{props.InterestItem.name}</p>
        </InterestItem>
    )
}